//
//
//
//
//
//
//

require('@/assets/data_database_icon_177024.png');
import LineageDs from './LineageDs.vue';
export default {
  name: 'DatasourceDsTabLineage',
  components: {
    LineageDs: LineageDs
  },
  props: {
    item: {
      type: Object,
      default: function _default() {}
    }
  },
  watch: {
    'item.datasources': function itemDatasources(newVal, oldVal) {
      console.log("change datasources");
      this.loadLineage();
    },
    'item.object_name': function itemObject_name(newVal, oldVal) {
      console.log("change object_name");
      this.loadLineage();
    }
  },
  computed: {},
  data: function data() {
    return {
      dataset: {},
      reports: {},
      data_lineage: {
        dataset: {}
      },
      key_lineage: 1
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.loadLineage();
    //this.detDataset()
  },
  methods: {
    loadLineage: function loadLineage() {
      this.key_lineage += 1;
      if (this.item.datasources) this.item.datasources.forEach(function (element) {
        element.type = "DATASOURCE";
      });
      var element = Object.assign({}, this.item);
      element.type = 'REPORT';
      this.data_lineage = {
        dataset: element,
        tables: this.item.datasources,
        reports: this.item.reports
      };
    }
  }
};